"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SourceSettings = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CameraSourceSettings = require("./CameraSourceSettings");
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../constants");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
var SourceSettings = exports.SourceSettings = function SourceSettings(_ref) {
  var meetingSession = _ref.meetingSession,
    source = _ref.source,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    audioInputDeviceId = _ref.audioInputDeviceId,
    audioOutputDeviceId = _ref.audioOutputDeviceId,
    videoInputDeviceId = _ref.videoInputDeviceId,
    _ref$userBackground = _ref.userBackground,
    userBackground = _ref$userBackground === void 0 ? _VirtualBackground.BACKGROUND_OPTIONS.NONE : _ref$userBackground;
  var cameraSourceSettings = /*#__PURE__*/_react["default"].createElement(_CameraSourceSettings.CameraSourceSettings, {
    meetingSession: meetingSession,
    title: source.title,
    description: source === null || source === void 0 ? void 0 : source.description,
    onCancel: onCancel,
    onSubmit: onSubmit,
    audioInputDeviceId: audioInputDeviceId,
    audioOutputDeviceId: audioOutputDeviceId,
    videoInputDeviceId: videoInputDeviceId,
    userBackground: userBackground
  });
  var mapSourcesToSettings = (0, _defineProperty2["default"])({}, _constants.CAMERA_PRESENTER, cameraSourceSettings);
  return mapSourcesToSettings[source.type] || null;
};
SourceSettings.propTypes = {
  meetingSession: _propTypes["default"].object.isRequired,
  source: _propTypes["default"].object.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  audioInputDeviceId: _propTypes["default"].string,
  audioOutputDeviceId: _propTypes["default"].string,
  videoInputDeviceId: _propTypes["default"].string,
  userBackground: _propTypes["default"].oneOf([_VirtualBackground.BACKGROUND_OPTIONS.NONE, _VirtualBackground.BACKGROUND_OPTIONS.BLUR, _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM])
};